function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useRef as b, useEffect as L } from "react";
import { Keys as v } from "../components/keyboard.js";
import { focusElement as o, focusIn as H, Focus as T, FocusResult as R } from "../utils/focus-management.js";
import { useEventListener as d } from "./use-event-listener.js";
import { useIsMounted as i } from "./use-is-mounted.js";
import { useOwnerDocument as O } from "./use-owner.js";

var j = function (r) {
  return r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r;
}(j || {});

function B(u) {
  var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      t = _ref.initialFocus,
      s = _ref.containers;

  var m = b(null),
      c = b(null),
      r = i(),
      M = Boolean(f & 16),
      a = Boolean(f & 2),
      e = O(u);
  return L(function () {
    !M || m.current || (m.current = e == null ? void 0 : e.activeElement);
  }, [M, e]), L(function () {
    if (!!M) return function () {
      o(m.current), m.current = null;
    };
  }, [M]), L(function () {
    if (!a) return;
    var l = u.current;
    if (!l) return;
    var n = e == null ? void 0 : e.activeElement;

    if (t != null && t.current) {
      if ((t == null ? void 0 : t.current) === n) {
        c.current = n;
        return;
      }
    } else if (l.contains(n)) {
      c.current = n;
      return;
    }

    t != null && t.current ? o(t.current) : H(l, T.First) === R.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), c.current = e == null ? void 0 : e.activeElement;
  }, [u, t, a, e]), d(e == null ? void 0 : e.defaultView, "keydown", function (l) {
    !(f & 4) || !u.current || l.key === v.Tab && (l.preventDefault(), H(u.current, (l.shiftKey ? T.Previous : T.Next) | T.WrapAround) === R.Success && (c.current = e == null ? void 0 : e.activeElement));
  }), d(e == null ? void 0 : e.defaultView, "focus", function (l) {
    if (!(f & 8)) return;
    var n = new Set(s == null ? void 0 : s.current);
    if (n.add(u), !n.size) return;
    var p = c.current;
    if (!p || !r.current) return;
    var E = l.target;
    E && E instanceof HTMLElement ? k(n, E) ? (c.current = E, o(E)) : (l.preventDefault(), l.stopPropagation(), o(p)) : o(c.current);
  }, !0), m;
}

function k(u, f) {
  var t;

  var _iterator = _createForOfIteratorHelper(u),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      if ((t = s.current) != null && t.contains(f)) return !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !1;
}

export { j as Features, B as useFocusTrap };